import { Controller } from "@hotwired/stimulus";
import levenshtein from "js-levenshtein";

const commonDomains = [
  "gmail.com",
  "hotmail.com",
  "outlook.com",
  "icloud.com",
  "yahoo.com",
  "qq.com",
  "me.com",
  "protonmail.com",
  "proton.me",
];

// Connects to data-controller="email"
export default class extends Controller {
  static targets = ["email", "feedback"];

  check() {
    const [_localPart, domain] = this.emailTarget.value.split("@", 2);

    if (domain) {
      for (const commonDomain of commonDomains) {
        const distance = levenshtein(domain, commonDomain);
        if (distance === 1 || distance === 2) {
          const suggestion = this.emailTarget.value.replace(
            `@${domain}`,
            `@${commonDomain}`,
          );
          this.feedbackTarget.innerText = `Did you mean ${suggestion}?`;
          this.feedbackTarget.classList.remove("hidden");
          return;
        }
      }
    }

    this.feedbackTarget.classList.add("hidden");
  }
}
